import ErrorPage from './src/ErrorPage'

export default ErrorPage
